export default {"src":"/_next/static/media/safeguard.12e8d3b6.svg","height":45,"width":45};